import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import AccountsBodyScreen from './AccountsBodyScreen'
import { useNavigation } from '@react-navigation/native'

const AccountsScreen = () => {
  const navigate = useNavigation()
  return (
    <View>
      <TopHeaderComponent headerText={'Choose Account'} hideScreen={() => navigate.push('profile')} paddingTop={60} />
      <AccountsBodyScreen />
    </View>
  )
}

const styles = StyleSheet.create({})

export default AccountsScreen
